/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddColumnsToSchemaRequest,
  AlertDto,
  AlertExecutionDto,
  AlertStatus,
  AnnotationDto,
  AnnotationsDataDto,
  AssignTicketRequestDto,
  BulkVariableScadaDto,
  CalculationType,
  ChartAnnotationsDto,
  ChartQueryDto,
  ChartQueryFilterRequestDto,
  CheckVariableTaskRequestDto,
  ClientDto,
  ClientStatisticsResponseDto,
  CreateAlertDto,
  CreateAlertExecutionDto,
  CreateAnnotationDto,
  CreateAnnotationsDataDto,
  CreateChartAnnotationsDto,
  CreateChartQueryDto,
  CreateClientDto,
  CreateCsvRecordBatchItemRequest,
  CreateCsvRecordRequest,
  CreateCsvSchemaRequest,
  CreateDashboardDto,
  CreateDashboardGroupDto,
  CreateDataExportDto,
  CreateDeviceDto,
  CreateDiagramDto,
  CreateDiagramEdgeDto,
  CreateDiagramNodeDto,
  CreateEditRemoveResponseDto,
  CreateLayoutDto,
  CreateNotificationDto,
  CreatePlantDto,
  CreateResponseDto,
  CreateRoleDto,
  CreateRolePermissionDto,
  CreateTableAdvanceDto,
  CreateTableDto,
  CreateTelegramGroupDto,
  CreateTemplateExportScheduleDto,
  CreateTicketDto,
  CreateUserDto,
  CreateVariableDto,
  CreateVariableScadaDto,
  CreateVariableTaskDto,
  CreateZoneDto,
  CsvColumnResponse,
  CsvRecordFilterRequestDto,
  CsvRecordResponse,
  CsvSchemaResponse,
  DashboardDto,
  DashboardGroupDto,
  DataRangeExportDto,
  DiagramBulkPositionUpdateRequest,
  DiagramDto,
  DiagramEdgeDto,
  DiagramNodeDto,
  EntityType,
  EnviarAlertaRequest,
  ExecuteTasksInRangeRequestDto,
  ExportFileType,
  ForgotPasswordRequestDto,
  LayoutDto,
  Limit,
  LoginRequestDto,
  Metric,
  NotificationPriority,
  NotificationType,
  OrderType,
  PlantDto,
  ProblemDetails,
  RefreshTokenRequestDto,
  ResetPasswordRequestDto,
  RoleDto,
  RolePermissionDto,
  SendMailRequestDto,
  SendTemplateExportRequestDto,
  SendTemplatedMailRequestDto,
  StatisticsResponseDto,
  TableAdvanceDto,
  TableDto,
  TestVariableTaskRequestDto,
  TicketCategory,
  TicketPriority,
  TicketStatus,
  UpdateDataExportRequestDto,
  UpdateDataRangeRequestDto,
  UpdateDiagramRequestDto,
  UpdateExportTemplateRequest,
  UpdateTemplateExportScheduleRequestDto,
  UpdateTicketStatusRequestDto,
  VariableDto,
  VariableScadaDto,
  VariableTaskDto,
  ZoneDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsCreate
   * @request POST:/api/Alerts
   * @secure
   */
  alertsCreate = (data: CreateAlertDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsUpdate
   * @request PUT:/api/Alerts
   * @secure
   */
  alertsUpdate = (data: AlertDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsList
   * @request GET:/api/Alerts
   * @secure
   */
  alertsList = (
    query?: {
      SearchString?: string;
      /** @format date-time */
      CreationStartDate?: string;
      /** @format date-time */
      CreationEndDate?: string;
      /** @format date-time */
      LastUpdateStartDate?: string;
      /** @format date-time */
      LastUpdateEndDate?: string;
      Status?: AlertStatus;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      /** @format int32 */
      VariableId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Alerts`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsDetail
   * @request GET:/api/Alerts/{id}
   * @secure
   */
  alertsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsDelete
   * @request DELETE:/api/Alerts/{id}
   * @secure
   */
  alertsDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsByPlantDetail
   * @request GET:/api/Alerts/byPlant/{plantId}
   * @secure
   */
  alertsByPlantDetail = (plantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts/byPlant/${plantId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsByVariableDetail
   * @request GET:/api/Alerts/byVariable/{variableId}
   * @secure
   */
  alertsByVariableDetail = (variableId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts/byVariable/${variableId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsByZoneDetail
   * @request GET:/api/Alerts/byZone/{zoneId}
   * @secure
   */
  alertsByZoneDetail = (zoneId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts/byZone/${zoneId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsExecutionCreate
   * @request POST:/api/Alerts/execution
   * @secure
   */
  alertsExecutionCreate = (
    data: CreateAlertExecutionDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Alerts/execution`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsExecutionUpdate
   * @request PUT:/api/Alerts/execution
   * @secure
   */
  alertsExecutionUpdate = (
    data: AlertExecutionDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Alerts/execution`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsExecutionList
   * @request GET:/api/Alerts/execution
   * @secure
   */
  alertsExecutionList = (
    query?: {
      /** @format date-time */
      StartDate?: string;
      /** @format date-time */
      EndDate?: string;
      LimitSurpassed?: Limit;
      TriggeredStatus?: AlertStatus;
      /** @format int32 */
      AlertId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Alerts/execution`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsExecutionDetail
   * @request GET:/api/Alerts/execution/{id}
   * @secure
   */
  alertsExecutionDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts/execution/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsExecutionByAlertDetail
   * @request GET:/api/Alerts/execution/byAlert/{alertId}
   * @secure
   */
  alertsExecutionByAlertDetail = (
    alertId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Alerts/execution/byAlert/${alertId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Alerts
   * @name AlertsExecutionLastDetail
   * @request GET:/api/Alerts/execution/last/{alertId}
   * @secure
   */
  alertsExecutionLastDetail = (alertId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Alerts/execution/last/${alertId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Annotations
   * @name AnnotationsList
   * @request GET:/api/Annotations
   * @secure
   */
  annotationsList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Annotations`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Annotations
   * @name AnnotationsCreate
   * @request POST:/api/Annotations
   * @secure
   */
  annotationsCreate = (data: CreateAnnotationDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Annotations`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Annotations
   * @name AnnotationsDetail
   * @request GET:/api/Annotations/{id}
   * @secure
   */
  annotationsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Annotations/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Annotations
   * @name AnnotationsUpdate
   * @request PUT:/api/Annotations/{id}
   * @secure
   */
  annotationsUpdate = (
    id: number,
    data: AnnotationDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Annotations/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Annotations
   * @name AnnotationsDelete
   * @request DELETE:/api/Annotations/{id}
   * @secure
   */
  annotationsDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Annotations/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Annotations
   * @name AnnotationsByZoneDetail
   * @request GET:/api/Annotations/by-zone/{zoneId}
   * @secure
   */
  annotationsByZoneDetail = (zoneId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Annotations/by-zone/${zoneId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataList
   * @request GET:/api/AnnotationsData
   * @secure
   */
  annotationsDataList = (
    query?: {
      /** @format date-time */
      StartDate?: string;
      /** @format date-time */
      EndDate?: string;
      SearchString?: string;
      /** @format int32 */
      AnnotationId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/AnnotationsData`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataCreate
   * @request POST:/api/AnnotationsData
   * @secure
   */
  annotationsDataCreate = (
    data: CreateAnnotationsDataDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/AnnotationsData`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataDetail
   * @request GET:/api/AnnotationsData/{id}
   * @secure
   */
  annotationsDataDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AnnotationsData/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataUpdate
   * @request PUT:/api/AnnotationsData/{id}
   * @secure
   */
  annotationsDataUpdate = (
    id: number,
    data: AnnotationsDataDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/AnnotationsData/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataDelete
   * @request DELETE:/api/AnnotationsData/{id}
   * @secure
   */
  annotationsDataDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AnnotationsData/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataByAnnotationDetail
   * @request GET:/api/AnnotationsData/by-annotation/{annotationId}
   * @secure
   */
  annotationsDataByAnnotationDetail = (
    annotationId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/AnnotationsData/by-annotation/${annotationId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataByDatesList
   * @request GET:/api/AnnotationsData/by-dates
   * @secure
   */
  annotationsDataByDatesList = (
    query?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/AnnotationsData/by-dates`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AnnotationsData
   * @name AnnotationsDataByAnnotationDatesList
   * @request GET:/api/AnnotationsData/by-annotation-dates
   * @secure
   */
  annotationsDataByAnnotationDatesList = (
    query?: {
      /** @format int32 */
      annotationId?: number;
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/AnnotationsData/by-annotation-dates`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Audit
   * @name AuditList
   * @request GET:/api/Audit
   * @secure
   */
  auditList = (
    query?: {
      ActorUserId?: string;
      TargetUserId?: string;
      Action?: string;
      /** @format date-time */
      FromUtc?: string;
      /** @format date-time */
      ToUtc?: string;
      Search?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 20
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Audit`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartAnnotations
   * @name ChartAnnotationsList
   * @request GET:/api/ChartAnnotations
   * @secure
   */
  chartAnnotationsList = (
    query?: {
      /** @format int32 */
      ChartQueryId?: number;
      /** @format int32 */
      AnnotationId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ChartAnnotations`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartAnnotations
   * @name ChartAnnotationsCreate
   * @request POST:/api/ChartAnnotations
   * @secure
   */
  chartAnnotationsCreate = (
    data: CreateChartAnnotationsDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ChartAnnotations`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartAnnotations
   * @name ChartAnnotationsUpdate
   * @request PUT:/api/ChartAnnotations
   * @secure
   */
  chartAnnotationsUpdate = (
    data: ChartAnnotationsDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ChartAnnotations`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartAnnotations
   * @name ChartAnnotationsDetail
   * @request GET:/api/ChartAnnotations/{id}
   * @secure
   */
  chartAnnotationsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ChartAnnotations/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartAnnotations
   * @name ChartAnnotationsDelete
   * @request DELETE:/api/ChartAnnotations/{id}
   * @secure
   */
  chartAnnotationsDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ChartAnnotations/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartAnnotations
   * @name ChartAnnotationsByChartqueryDetail
   * @request GET:/api/ChartAnnotations/by-chartquery/{chartQueryId}
   * @secure
   */
  chartAnnotationsByChartqueryDetail = (
    chartQueryId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ChartAnnotations/by-chartquery/${chartQueryId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesList
   * @request GET:/api/ChartQueries
   * @secure
   */
  chartQueriesList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ChartQueries`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesCreate
   * @request POST:/api/ChartQueries
   * @secure
   */
  chartQueriesCreate = (
    data: CreateChartQueryDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateResponseDto, any>({
      path: `/api/ChartQueries`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesDetail
   * @request GET:/api/ChartQueries/{id}
   * @secure
   */
  chartQueriesDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ChartQueries/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesUpdate
   * @request PUT:/api/ChartQueries/{id}
   * @secure
   */
  chartQueriesUpdate = (
    id: number,
    data: ChartQueryDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/ChartQueries/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesDelete
   * @request DELETE:/api/ChartQueries/{id}
   * @secure
   */
  chartQueriesDelete = (id: number, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/ChartQueries/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesByLayoutDetail
   * @request GET:/api/ChartQueries/ByLayout/{layoutId}
   * @secure
   */
  chartQueriesByLayoutDetail = (layoutId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ChartQueries/ByLayout/${layoutId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesByDashboardDetail
   * @request GET:/api/ChartQueries/ByDashboard/{dashboardId}
   * @secure
   */
  chartQueriesByDashboardDetail = (
    dashboardId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ChartQueries/ByDashboard/${dashboardId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesByValueNodeDetail
   * @request GET:/api/ChartQueries/ByValueNode/{nodeId}
   * @secure
   */
  chartQueriesByValueNodeDetail = (
    nodeId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ChartQueries/ByValueNode/${nodeId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesBatchUpdate
   * @request PUT:/api/ChartQueries/batch
   * @secure
   */
  chartQueriesBatchUpdate = (
    data: ChartQueryDto[],
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/ChartQueries/batch`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesBatchDelete
   * @request DELETE:/api/ChartQueries/Batch
   * @secure
   */
  chartQueriesBatchDelete = (data: number[], params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/ChartQueries/Batch`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ChartQueries
   * @name ChartQueriesApplyFiltersByDashboardIdFilterRequestDashboardIdUpdate
   * @request PUT:/api/ChartQueries/ApplyFiltersByDashboardId/{filterRequest.DashboardId}
   * @secure
   */
  chartQueriesApplyFiltersByDashboardIdFilterRequestDashboardIdUpdate = (
    filterRequestDashboardId: string,
    data: ChartQueryFilterRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ChartQueries/ApplyFiltersByDashboardId/${filterRequestDashboardId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsList
   * @request GET:/api/Clients
   * @secure
   */
  clientsList = (
    query?: {
      SearchString?: string;
      /** @default true */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Clients`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsCreate
   * @request POST:/api/Clients
   * @secure
   */
  clientsCreate = (data: CreateClientDto, params: RequestParams = {}) =>
    this.request<CreateResponseDto, any>({
      path: `/api/Clients`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsDetail
   * @request GET:/api/Clients/{id}
   * @secure
   */
  clientsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Clients/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsUpdate
   * @request PUT:/api/Clients/{id}
   * @secure
   */
  clientsUpdate = (id: number, data: ClientDto, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Clients/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsDelete
   * @request DELETE:/api/Clients/{id}
   * @secure
   */
  clientsDelete = (
    id: number,
    query?: {
      pass?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Clients/${id}`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name ClientsPlantDashboardTreeList
   * @request GET:/api/Clients/plant-dashboard-tree
   * @secure
   */
  clientsPlantDashboardTreeList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Clients/plant-dashboard-tree`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvSchemasCreate
   * @request POST:/api/csv/schemas
   * @secure
   */
  csvSchemasCreate = (
    data: CreateCsvSchemaRequest,
    params: RequestParams = {}
  ) =>
    this.request<CsvSchemaResponse, ProblemDetails | void>({
      path: `/api/csv/schemas`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvSchemasColumnsCreate
   * @request POST:/api/csv/schemas/columns
   * @secure
   */
  csvSchemasColumnsCreate = (
    data: AddColumnsToSchemaRequest,
    params: RequestParams = {}
  ) =>
    this.request<CsvColumnResponse[], ProblemDetails | void>({
      path: `/api/csv/schemas/columns`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvSchemasDetail
   * @request GET:/api/csv/schemas/{id}
   * @secure
   */
  csvSchemasDetail = (id: number, params: RequestParams = {}) =>
    this.request<CsvSchemaResponse, ProblemDetails | void>({
      path: `/api/csv/schemas/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvSchemasDelete
   * @request DELETE:/api/csv/schemas/{id}
   * @secure
   */
  csvSchemasDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/api/csv/schemas/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvSchemasPlantDetail
   * @request GET:/api/csv/schemas/plant/{plantId}
   * @secure
   */
  csvSchemasPlantDetail = (plantId: number, params: RequestParams = {}) =>
    this.request<CsvSchemaResponse[], ProblemDetails | void>({
      path: `/api/csv/schemas/plant/${plantId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvRecordsCreate
   * @request POST:/api/csv/records
   * @secure
   */
  csvRecordsCreate = (
    data: CreateCsvRecordRequest,
    params: RequestParams = {}
  ) =>
    this.request<CsvRecordResponse, ProblemDetails | void>({
      path: `/api/csv/records`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvRecordsBatchCreate
   * @request POST:/api/csv/records/batch
   * @secure
   */
  csvRecordsBatchCreate = (
    data: CreateCsvRecordRequest[],
    params: RequestParams = {}
  ) =>
    this.request<CsvRecordResponse[], ProblemDetails | void>({
      path: `/api/csv/records/batch`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvRecordsBatchCreate2
   * @request POST:/api/csv/records/batch/{csvSchemaId}
   * @originalName csvRecordsBatchCreate
   * @duplicate
   * @secure
   */
  csvRecordsBatchCreate2 = (
    csvSchemaId: number,
    data: CreateCsvRecordBatchItemRequest[],
    params: RequestParams = {}
  ) =>
    this.request<CsvRecordResponse[], ProblemDetails | void>({
      path: `/api/csv/records/batch/${csvSchemaId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvRecordsDetail
   * @request GET:/api/csv/records/{id}
   * @secure
   */
  csvRecordsDetail = (id: number, params: RequestParams = {}) =>
    this.request<CsvRecordResponse, ProblemDetails | void>({
      path: `/api/csv/records/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvRecordsSchemaDetail
   * @request GET:/api/csv/records/schema/{schemaId}
   * @secure
   */
  csvRecordsSchemaDetail = (
    schemaId: number,
    query?: {
      /** @format date-time */
      fromDate?: string;
      /** @format date-time */
      toDate?: string;
      /**
       * @format int32
       * @default 100
       */
      limit?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<CsvRecordResponse[], ProblemDetails | void>({
      path: `/api/csv/records/schema/${schemaId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CsvIngestion
   * @name CsvRecordsFilterCreate
   * @request POST:/api/csv/records/filter
   * @secure
   */
  csvRecordsFilterCreate = (
    data: CsvRecordFilterRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<CsvRecordResponse[], ProblemDetails | void>({
      path: `/api/csv/records/filter`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsList
   * @request GET:/api/DashboardGroups
   * @secure
   */
  dashboardGroupsList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      Position?: number;
      /** @format int32 */
      PlantId?: number;
      /** @default true */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DashboardGroups`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsCreate
   * @request POST:/api/DashboardGroups
   * @secure
   */
  dashboardGroupsCreate = (
    data: CreateDashboardGroupDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateResponseDto, any>({
      path: `/api/DashboardGroups`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsByPlantList
   * @request GET:/api/DashboardGroups/ByPlant
   * @secure
   */
  dashboardGroupsByPlantList = (
    query?: {
      /** @format int32 */
      id?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DashboardGroups/ByPlant`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsGetListAdminList
   * @request GET:/api/DashboardGroups/GetListAdmin
   * @secure
   */
  dashboardGroupsGetListAdminList = (
    query?: {
      /** @default "["id","ASC"]" */
      sort?: string;
      /** @default "[0,9]" */
      range?: string;
      /** @default "{}" */
      filter?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DashboardGroups/GetListAdmin`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsDetail
   * @request GET:/api/DashboardGroups/{id}
   * @secure
   */
  dashboardGroupsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/DashboardGroups/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsUpdate
   * @request PUT:/api/DashboardGroups/{id}
   * @secure
   */
  dashboardGroupsUpdate = (
    id: number,
    data: DashboardGroupDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/DashboardGroups/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsDelete
   * @request DELETE:/api/DashboardGroups/{id}
   * @secure
   */
  dashboardGroupsDelete = (id: number, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/DashboardGroups/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DashboardGroups
   * @name DashboardGroupsRangeUpdate
   * @request PUT:/api/DashboardGroups/range
   * @secure
   */
  dashboardGroupsRangeUpdate = (
    data: DashboardGroupDto[],
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/DashboardGroups/range`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboards
   * @name DashboardsList
   * @request GET:/api/Dashboards
   * @secure
   */
  dashboardsList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      Position?: number;
      /** @format int32 */
      DashboardGroupId?: number;
      /** @default true */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Dashboards`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboards
   * @name DashboardsCreate
   * @request POST:/api/Dashboards
   * @secure
   */
  dashboardsCreate = (data: CreateDashboardDto, params: RequestParams = {}) =>
    this.request<CreateResponseDto, any>({
      path: `/api/Dashboards`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboards
   * @name DashboardsDetail
   * @request GET:/api/Dashboards/{id}
   * @secure
   */
  dashboardsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Dashboards/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboards
   * @name DashboardsUpdate
   * @request PUT:/api/Dashboards/{id}
   * @secure
   */
  dashboardsUpdate = (
    id: number,
    data: DashboardDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Dashboards/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboards
   * @name DashboardsDelete
   * @request DELETE:/api/Dashboards/{id}
   * @secure
   */
  dashboardsDelete = (id: number, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Dashboards/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboards
   * @name DashboardsByDashboardGroupDetail
   * @request GET:/api/Dashboards/ByDashboardGroup/{dashboardGroupId}
   * @secure
   */
  dashboardsByDashboardGroupDetail = (
    dashboardGroupId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Dashboards/ByDashboardGroup/${dashboardGroupId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboards
   * @name DashboardsRangeUpdate
   * @request PUT:/api/Dashboards/range
   * @secure
   */
  dashboardsRangeUpdate = (data: DashboardDto[], params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Dashboards/range`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramEdges
   * @name DiagramEdgesDetail
   * @request GET:/api/DiagramEdges/{id}
   * @secure
   */
  diagramEdgesDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/DiagramEdges/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramEdges
   * @name DiagramEdgesUpdate
   * @request PUT:/api/DiagramEdges/{id}
   * @secure
   */
  diagramEdgesUpdate = (
    id: number,
    data: DiagramEdgeDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/DiagramEdges/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramEdges
   * @name DiagramEdgesDelete
   * @request DELETE:/api/DiagramEdges/{id}
   * @secure
   */
  diagramEdgesDelete = (id: number, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/DiagramEdges/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramEdges
   * @name DiagramEdgesByDiagramDetail
   * @request GET:/api/DiagramEdges/ByDiagram/{diagramId}
   * @secure
   */
  diagramEdgesByDiagramDetail = (
    diagramId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DiagramEdges/ByDiagram/${diagramId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramEdges
   * @name DiagramEdgesCreate
   * @request POST:/api/DiagramEdges
   * @secure
   */
  diagramEdgesCreate = (
    data: CreateDiagramEdgeDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DiagramEdges`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramNode
   * @name DiagramNodeBulkUpdate
   * @request PUT:/api/DiagramNode/bulk
   * @secure
   */
  diagramNodeBulkUpdate = (
    data: DiagramBulkPositionUpdateRequest,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DiagramNode/bulk`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramNode
   * @name DiagramNodeDetail
   * @request GET:/api/DiagramNode/{id}
   * @secure
   */
  diagramNodeDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/DiagramNode/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramNode
   * @name DiagramNodeUpdate
   * @request PUT:/api/DiagramNode/{id}
   * @secure
   */
  diagramNodeUpdate = (
    id: number,
    data: DiagramNodeDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/DiagramNode/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramNode
   * @name DiagramNodeDelete
   * @request DELETE:/api/DiagramNode/{id}
   * @secure
   */
  diagramNodeDelete = (id: number, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/DiagramNode/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramNode
   * @name DiagramNodeByDiagramDetail
   * @request GET:/api/DiagramNode/ByDiagram/{diagramId}
   * @secure
   */
  diagramNodeByDiagramDetail = (
    diagramId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DiagramNode/ByDiagram/${diagramId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DiagramNode
   * @name DiagramNodeCreate
   * @request POST:/api/DiagramNode
   * @secure
   */
  diagramNodeCreate = (
    data: CreateDiagramNodeDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/DiagramNode`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Diagrams
   * @name DiagramsList
   * @request GET:/api/Diagrams
   * @secure
   */
  diagramsList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format date-time */
      CreatedStart?: string;
      /** @format date-time */
      CreatedEnd?: string;
      /** @format date-time */
      UpdatedStart?: string;
      /** @format date-time */
      UpdatedEnd?: string;
      /** @default true */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
      include?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Diagrams`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Diagrams
   * @name DiagramsCreate
   * @request POST:/api/Diagrams
   * @secure
   */
  diagramsCreate = (data: CreateDiagramDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Diagrams`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Diagrams
   * @name DiagramsUpdate
   * @request PUT:/api/Diagrams
   * @secure
   */
  diagramsUpdate = (data: DiagramDto, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Diagrams`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Diagrams
   * @name DiagramsDetail
   * @request GET:/api/Diagrams/{id}
   * @secure
   */
  diagramsDetail = (
    id: number,
    query?: {
      include?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Diagrams/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Diagrams
   * @name DiagramsUpdate2
   * @request PUT:/api/Diagrams/{id}
   * @originalName diagramsUpdate
   * @duplicate
   * @secure
   */
  diagramsUpdate2 = (
    id: number,
    data: UpdateDiagramRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Diagrams/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Diagrams
   * @name DiagramsDelete
   * @request DELETE:/api/Diagrams/{id}
   * @secure
   */
  diagramsDelete = (id: number, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Diagrams/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Diagrams
   * @name DiagramsByPlantDetail
   * @request GET:/api/Diagrams/ByPlant/{plantId}
   * @secure
   */
  diagramsByPlantDetail = (plantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Diagrams/ByPlant/${plantId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportCreate
   * @request POST:/api/Export
   * @secure
   */
  exportCreate = (data: CreateDataExportDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Export`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportList
   * @request GET:/api/Export
   * @secure
   */
  exportList = (
    query?: {
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Export`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportUpdate
   * @request PUT:/api/Export
   * @secure
   */
  exportUpdate = (
    data: UpdateDataExportRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Export`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportDetail
   * @request GET:/api/Export/{id}
   * @secure
   */
  exportDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Export/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportDelete
   * @request DELETE:/api/Export/{id}
   * @secure
   */
  exportDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Export/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportByUserDetail
   * @request GET:/api/Export/byUser/{userId}
   * @secure
   */
  exportByUserDetail = (
    userId: string,
    query?: {
      SearchString?: string;
      ExpressionSearchString?: string;
      FileTypes?: ExportFileType[];
      OrderType?: OrderType;
      /** @default false */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Export/byUser/${userId}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportTemplateDownloadList
   * @request GET:/api/Export/template/{templateId}/download
   * @secure
   */
  exportTemplateDownloadList = (
    templateId: number,
    query?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Export/template/${templateId}/download`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Export
   * @name ExportIntervalDownloadCreate
   * @request POST:/api/Export/interval/download
   * @secure
   */
  exportIntervalDownloadCreate = (
    data: DataRangeExportDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Export/interval/download`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplateCreate
   * @request POST:/api/ExportTemplate
   * @secure
   */
  exportTemplateCreate = (
    data: {
      Name?: string;
      Description?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format binary */
      File?: File;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ExportTemplate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplateList
   * @request GET:/api/ExportTemplate
   * @secure
   */
  exportTemplateList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ExportTemplate`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplateDetail
   * @request GET:/api/ExportTemplate/{id}
   * @secure
   */
  exportTemplateDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ExportTemplate/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplateUpdate
   * @request PUT:/api/ExportTemplate/{id}
   * @secure
   */
  exportTemplateUpdate = (
    id: number,
    data: UpdateExportTemplateRequest,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ExportTemplate/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplateDelete
   * @request DELETE:/api/ExportTemplate/{id}
   * @secure
   */
  exportTemplateDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ExportTemplate/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplatePlantDetail
   * @request GET:/api/ExportTemplate/plant/{plantId}
   * @secure
   */
  exportTemplatePlantDetail = (plantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ExportTemplate/plant/${plantId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplatePlantWithslotsList
   * @request GET:/api/ExportTemplate/plant/{plantId}/withslots
   * @secure
   */
  exportTemplatePlantWithslotsList = (
    plantId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ExportTemplate/plant/${plantId}/withslots`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplateFileUpdate
   * @request PUT:/api/ExportTemplate/{id}/file
   * @secure
   */
  exportTemplateFileUpdate = (
    id: number,
    data: {
      /** @format binary */
      File?: File;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/ExportTemplate/${id}/file`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExportTemplate
   * @name ExportTemplateDownloadList2
   * @request GET:/api/ExportTemplate/{id}/download
   * @originalName exportTemplateDownloadList
   * @duplicate
   * @secure
   */
  exportTemplateDownloadList2 = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/ExportTemplate/${id}/download`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Layouts
   * @name LayoutsList
   * @request GET:/api/Layouts
   * @secure
   */
  layoutsList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Layouts`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Layouts
   * @name LayoutsCreate
   * @request POST:/api/Layouts
   * @secure
   */
  layoutsCreate = (data: CreateLayoutDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Layouts`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Layouts
   * @name LayoutsDetail
   * @request GET:/api/Layouts/{id}
   * @secure
   */
  layoutsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Layouts/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Layouts
   * @name LayoutsUpdate
   * @request PUT:/api/Layouts/{id}
   * @secure
   */
  layoutsUpdate = (id: number, data: LayoutDto, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Layouts/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Layouts
   * @name LayoutsDelete
   * @request DELETE:/api/Layouts/{id}
   * @secure
   */
  layoutsDelete = (id: number, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Layouts/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Layouts
   * @name LayoutsByDashboardDetail
   * @request GET:/api/Layouts/ByDashboard/{dashboardId}
   * @secure
   */
  layoutsByDashboardDetail = (
    dashboardId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Layouts/ByDashboard/${dashboardId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Layouts
   * @name LayoutsBulkUpdate
   * @request PUT:/api/Layouts/bulk
   * @secure
   */
  layoutsBulkUpdate = (data: LayoutDto[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Layouts/bulk`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsList
   * @request GET:/api/Notifications
   * @secure
   */
  notificationsList = (
    query?: {
      Type?: NotificationType;
      Priority?: NotificationPriority;
      IsRead?: boolean;
      /** @format date-time */
      FromDate?: string;
      /** @format date-time */
      ToDate?: string;
      SearchText?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Notifications`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsCreate
   * @request POST:/api/Notifications
   * @secure
   */
  notificationsCreate = (
    data: CreateNotificationDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Notifications`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsMarkReadCreate
   * @request POST:/api/Notifications/{id}/mark-read
   * @secure
   */
  notificationsMarkReadCreate = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Notifications/${id}/mark-read`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsUnreadCountList
   * @request GET:/api/Notifications/unread-count
   * @secure
   */
  notificationsUnreadCountList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Notifications/unread-count`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsAdminList
   * @request GET:/api/Notifications/admin
   * @secure
   */
  notificationsAdminList = (
    query?: {
      Type?: NotificationType;
      Priority?: NotificationPriority;
      IsRead?: boolean;
      /** @format date-time */
      FromDate?: string;
      /** @format date-time */
      ToDate?: string;
      SearchText?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Notifications/admin`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsDelete
   * @request DELETE:/api/Notifications/{id}
   * @secure
   */
  notificationsDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Notifications/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsDetail
   * @request GET:/api/Notifications/{id}
   * @secure
   */
  notificationsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Notifications/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsUpdate
   * @request PUT:/api/Notifications/{id}
   * @secure
   */
  notificationsUpdate = (
    id: number,
    data: CreateNotificationDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Notifications/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsPermanentDelete
   * @request DELETE:/api/Notifications/{id}/permanent
   * @secure
   */
  notificationsPermanentDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Notifications/${id}/permanent`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Plants
   * @name PlantsList
   * @request GET:/api/Plants
   * @secure
   */
  plantsList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      ClientId?: number;
      /** @default true */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Plants`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Plants
   * @name PlantsCreate
   * @request POST:/api/Plants
   * @secure
   */
  plantsCreate = (data: CreatePlantDto, params: RequestParams = {}) =>
    this.request<CreateResponseDto, any>({
      path: `/api/Plants`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Plants
   * @name PlantsUpdate
   * @request PUT:/api/Plants
   * @secure
   */
  plantsUpdate = (
    data: PlantDto,
    query?: {
      /** @format int32 */
      id?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Plants`,
      method: 'PUT',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Plants
   * @name PlantsDelete
   * @request DELETE:/api/Plants
   * @secure
   */
  plantsDelete = (
    query?: {
      /** @format int32 */
      id?: number;
      pass?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Plants`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Plants
   * @name PlantsDetail
   * @request GET:/api/Plants/{id}
   * @secure
   */
  plantsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Plants/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PlantStatus
   * @name PlantStatusDetail
   * @request GET:/api/PlantStatus/{plantId}
   * @secure
   */
  plantStatusDetail = (plantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/PlantStatus/${plantId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PlantStatus
   * @name PlantStatusScadaChangedUpdate
   * @request PUT:/api/PlantStatus/{plantId}/scada-changed
   * @secure
   */
  plantStatusScadaChangedUpdate = (
    plantId: number,
    query?: {
      value?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/PlantStatus/${plantId}/scada-changed`,
      method: 'PUT',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PlantStatus
   * @name PlantStatusDockerUpdateUpdate
   * @request PUT:/api/PlantStatus/{plantId}/docker-update
   * @secure
   */
  plantStatusDockerUpdateUpdate = (
    plantId: number,
    query?: {
      value?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/PlantStatus/${plantId}/docker-update`,
      method: 'PUT',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PlantStatus
   * @name PlantStatusDockerUpdateAllUpdate
   * @request PUT:/api/PlantStatus/docker-update-all
   * @secure
   */
  plantStatusDockerUpdateAllUpdate = (
    query?: {
      value?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/PlantStatus/docker-update-all`,
      method: 'PUT',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PlantStatus
   * @name PlantStatusDataRangeUpdate
   * @request PUT:/api/PlantStatus/{plantId}/data-range
   * @secure
   */
  plantStatusDataRangeUpdate = (
    plantId: number,
    data: UpdateDataRangeRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/PlantStatus/${plantId}/data-range`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PlantStatus
   * @name PlantStatusDataRangeAllUpdate
   * @request PUT:/api/PlantStatus/data-range-all
   * @secure
   */
  plantStatusDataRangeAllUpdate = (
    data: UpdateDataRangeRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/PlantStatus/data-range-all`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RoleCreate
   * @request POST:/api/Role
   * @secure
   */
  roleCreate = (data: CreateRoleDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Role`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RoleList
   * @request GET:/api/Role
   * @secure
   */
  roleList = (
    query?: {
      isPaginated?: boolean;
      SearchString?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RoleDelete
   * @request DELETE:/api/Role/{id}
   * @secure
   */
  roleDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Role/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RoleUpdate
   * @request PUT:/api/Role/{id}
   * @secure
   */
  roleUpdate = (id: string, data: RoleDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Role/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RoleDetail
   * @request GET:/api/Role/{id}
   * @secure
   */
  roleDetail = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Role/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsCreate
   * @request POST:/api/Role/permissions
   * @secure
   */
  rolePermissionsCreate = (
    data: CreateRolePermissionDto[],
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role/permissions`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsUpdate
   * @request PUT:/api/Role/permissions
   * @secure
   */
  rolePermissionsUpdate = (
    data: RolePermissionDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role/permissions`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsList
   * @request GET:/api/Role/permissions
   * @secure
   */
  rolePermissionsList = (
    query?: {
      /** @default false */
      needsEntity?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role/permissions`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsDelete
   * @request DELETE:/api/Role/permissions/{id}
   * @secure
   */
  rolePermissionsDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Role/permissions/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsDetail
   * @request GET:/api/Role/permissions/{id}
   * @secure
   */
  rolePermissionsDetail = (
    id: number,
    query?: {
      /** @default false */
      needsEntity?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role/permissions/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsByRoleDetail
   * @request GET:/api/Role/permissions/byRole/{roleId}
   * @secure
   */
  rolePermissionsByRoleDetail = (
    roleId: string,
    query?: {
      /** @default false */
      needsEntity?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role/permissions/byRole/${roleId}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsByEntityList
   * @request GET:/api/Role/permissions/byEntity
   * @secure
   */
  rolePermissionsByEntityList = (
    query?: {
      entityType?: EntityType;
      /**
       * @format int32
       * @default 0
       */
      entityId?: number;
      /** @default false */
      needsEntity?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role/permissions/byEntity`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name RolePermissionsFilteredList
   * @request GET:/api/Role/permissions/filtered
   * @secure
   */
  rolePermissionsFilteredList = (
    query?: {
      roleId?: string;
      entityType?: EntityType;
      /**
       * @format int32
       * @default 0
       */
      entityId?: number;
      /** @default false */
      needsEntity?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Role/permissions/filtered`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Statistics
   * @name StatisticsGeneralList
   * @request GET:/api/Statistics/general
   * @secure
   */
  statisticsGeneralList = (params: RequestParams = {}) =>
    this.request<StatisticsResponseDto, ProblemDetails | void>({
      path: `/api/Statistics/general`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Statistics
   * @name StatisticsByClientList
   * @request GET:/api/Statistics/by-client
   * @secure
   */
  statisticsByClientList = (params: RequestParams = {}) =>
    this.request<ClientStatisticsResponseDto[], ProblemDetails | void>({
      path: `/api/Statistics/by-client`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesList
   * @request GET:/api/Tables
   * @secure
   */
  tablesList = (
    query?: {
      isPaginated?: boolean;
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tables`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesCreate
   * @request POST:/api/Tables
   * @secure
   */
  tablesCreate = (data: CreateTableDto, params: RequestParams = {}) =>
    this.request<CreateResponseDto, any>({
      path: `/api/Tables`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesAdvanceList
   * @request GET:/api/Tables/Advance
   * @secure
   */
  tablesAdvanceList = (
    query?: {
      isPaginated?: boolean;
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tables/Advance`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesAdvanceCreate
   * @request POST:/api/Tables/Advance
   * @secure
   */
  tablesAdvanceCreate = (
    data: CreateTableAdvanceDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateResponseDto, any>({
      path: `/api/Tables/Advance`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesDetail
   * @request GET:/api/Tables/{id}
   * @secure
   */
  tablesDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tables/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesUpdate
   * @request PUT:/api/Tables/{id}
   * @secure
   */
  tablesUpdate = (id: number, data: TableDto, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Tables/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesDelete
   * @request DELETE:/api/Tables/{id}
   * @secure
   */
  tablesDelete = (
    id: number,
    query?: {
      pass?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Tables/${id}`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesAdvanceDetail
   * @request GET:/api/Tables/Advance/{id}
   * @secure
   */
  tablesAdvanceDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tables/Advance/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesAdvanceUpdate
   * @request PUT:/api/Tables/Advance/{id}
   * @secure
   */
  tablesAdvanceUpdate = (
    id: number,
    data: TableAdvanceDto,
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Tables/Advance/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesByZoneDetail
   * @request GET:/api/Tables/ByZone/{zoneId}
   * @secure
   */
  tablesByZoneDetail = (zoneId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tables/ByZone/${zoneId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesAdvanceByZoneDetail
   * @request GET:/api/Tables/Advance/ByZone/{zoneId}
   * @secure
   */
  tablesAdvanceByZoneDetail = (zoneId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tables/Advance/ByZone/${zoneId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tables
   * @name TablesByZoneAndNameDetail
   * @request GET:/api/Tables/byZone/{zoneId}/andName/{tableName}
   * @secure
   */
  tablesByZoneAndNameDetail = (
    zoneId: number,
    tableName: string,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tables/byZone/${zoneId}/andName/${tableName}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Telegram
   * @name TelegramEnviarAlertaCreate
   * @request POST:/api/Telegram/enviar-alerta
   * @secure
   */
  telegramEnviarAlertaCreate = (
    data: EnviarAlertaRequest,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Telegram/enviar-alerta`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TelegramClient
   * @name TelegramClientLoginRequestCreate
   * @request POST:/api/TelegramClient/login/request
   * @secure
   */
  telegramClientLoginRequestCreate = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/TelegramClient/login/request`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TelegramClient
   * @name TelegramClientLoginVerifyCreate
   * @request POST:/api/TelegramClient/login/verify
   * @secure
   */
  telegramClientLoginVerifyCreate = (
    data: string,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TelegramClient/login/verify`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TelegramClient
   * @name TelegramClientCreateGroupCreate
   * @request POST:/api/TelegramClient/CreateGroup
   * @secure
   */
  telegramClientCreateGroupCreate = (
    data: CreateTelegramGroupDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TelegramClient/CreateGroup`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TelegramClient
   * @name TelegramClientRemoveGroupDelete
   * @request DELETE:/api/TelegramClient/RemoveGroup
   * @secure
   */
  telegramClientRemoveGroupDelete = (
    query?: {
      roleId?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TelegramClient/RemoveGroup`,
      method: 'DELETE',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TelegramClient
   * @name TelegramClientRemoveCreate
   * @request POST:/api/TelegramClient/{roleId}/remove
   * @secure
   */
  telegramClientRemoveCreate = (
    roleId: string,
    data: string,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TelegramClient/${roleId}/remove`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TelegramClient
   * @name TelegramClientMessageCreate
   * @request POST:/api/TelegramClient/{roleId}/message
   * @secure
   */
  telegramClientMessageCreate = (
    roleId: string,
    data: string,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TelegramClient/${roleId}/message`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExportSchedule
   * @name TemplateExportScheduleCreate
   * @request POST:/api/TemplateExportSchedule
   * @secure
   */
  templateExportScheduleCreate = (
    data: CreateTemplateExportScheduleDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TemplateExportSchedule`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExportSchedule
   * @name TemplateExportScheduleUpdate
   * @request PUT:/api/TemplateExportSchedule
   * @secure
   */
  templateExportScheduleUpdate = (
    data: UpdateTemplateExportScheduleRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TemplateExportSchedule`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExportSchedule
   * @name TemplateExportScheduleList
   * @request GET:/api/TemplateExportSchedule
   * @secure
   */
  templateExportScheduleList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/TemplateExportSchedule`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExportSchedule
   * @name TemplateExportScheduleDelete
   * @request DELETE:/api/TemplateExportSchedule/{id}
   * @secure
   */
  templateExportScheduleDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/TemplateExportSchedule/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExportSchedule
   * @name TemplateExportScheduleDetail
   * @request GET:/api/TemplateExportSchedule/{id}
   * @secure
   */
  templateExportScheduleDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/TemplateExportSchedule/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExportSchedule
   * @name TemplateExportScheduleTriggerCreate
   * @request POST:/api/TemplateExportSchedule/{id}/trigger
   * @secure
   */
  templateExportScheduleTriggerCreate = (
    id: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TemplateExportSchedule/${id}/trigger`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExportSchedule
   * @name TemplateExportScheduleSendCreate
   * @request POST:/api/TemplateExportSchedule/send
   * @secure
   */
  templateExportScheduleSendCreate = (
    data: SendTemplateExportRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/TemplateExportSchedule/send`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsList
   * @request GET:/api/Tickets
   * @secure
   */
  ticketsList = (
    query?: {
      Status?: TicketStatus;
      Priority?: TicketPriority;
      Category?: TicketCategory;
      /** @format date-time */
      FromDate?: string;
      /** @format date-time */
      ToDate?: string;
      SearchText?: string;
      AssignedToUserId?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tickets`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsCreate
   * @request POST:/api/Tickets
   * @secure
   */
  ticketsCreate = (data: CreateTicketDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tickets`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsDetail
   * @request GET:/api/Tickets/{id}
   * @secure
   */
  ticketsDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tickets/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsUpdate
   * @request PUT:/api/Tickets/{id}
   * @secure
   */
  ticketsUpdate = (
    id: number,
    data: CreateTicketDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tickets/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsDelete
   * @request DELETE:/api/Tickets/{id}
   * @secure
   */
  ticketsDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tickets/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsAdminList
   * @request GET:/api/Tickets/admin
   * @secure
   */
  ticketsAdminList = (
    query?: {
      Status?: TicketStatus;
      Priority?: TicketPriority;
      Category?: TicketCategory;
      /** @format date-time */
      FromDate?: string;
      /** @format date-time */
      ToDate?: string;
      SearchText?: string;
      AssignedToUserId?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tickets/admin`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsStatusUpdate
   * @request PUT:/api/Tickets/{id}/status
   * @secure
   */
  ticketsStatusUpdate = (
    id: number,
    data: UpdateTicketStatusRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tickets/${id}/status`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsAdminStatisticsList
   * @request GET:/api/Tickets/admin/statistics
   * @secure
   */
  ticketsAdminStatisticsList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Tickets/admin/statistics`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tickets
   * @name TicketsAssignUpdate
   * @request PUT:/api/Tickets/{id}/assign
   * @secure
   */
  ticketsAssignUpdate = (
    id: number,
    data: AssignTicketRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Tickets/${id}/assign`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersList
   * @request GET:/api/Users
   * @secure
   */
  usersList = (
    query?: {
      SearchString?: string;
      /** @default true */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Users`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersCreate
   * @request POST:/api/Users
   * @secure
   */
  usersCreate = (data: CreateUserDto, params: RequestParams = {}) =>
    this.request<CreateResponseDto, any>({
      path: `/api/Users`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersDetail
   * @request GET:/api/Users/{id}
   * @secure
   */
  usersDetail = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Users/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersDelete
   * @request DELETE:/api/Users/{id}
   * @secure
   */
  usersDelete = (id: string, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Users/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersLoginCreate
   * @request POST:/api/Users/login
   * @secure
   */
  usersLoginCreate = (data: LoginRequestDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Users/login`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersRefreshCreate
   * @request POST:/api/Users/refresh
   * @secure
   */
  usersRefreshCreate = (
    data: RefreshTokenRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Users/refresh`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersLoggedList
   * @request GET:/api/Users/logged
   * @secure
   */
  usersLoggedList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Users/logged`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersRolesList
   * @request GET:/api/Users/roles
   * @secure
   */
  usersRolesList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Users/roles`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersRolebyuseridDetail
   * @request GET:/api/Users/rolebyuserid/{userId}
   * @secure
   */
  usersRolebyuseridDetail = (userId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Users/rolebyuserid/${userId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersUpdate
   * @request PUT:/api/Users/{userId}
   * @secure
   */
  usersUpdate = (
    userId: string,
    data: CreateUserDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Users/${userId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersSendemailList
   * @request GET:/api/Users/sendemail
   * @secure
   */
  usersSendemailList = (data: SendMailRequestDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Users/sendemail`,
      method: 'GET',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersSendtemplatedemailCreate
   * @request POST:/api/Users/sendtemplatedemail
   * @secure
   */
  usersSendtemplatedemailCreate = (
    data: SendTemplatedMailRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Users/sendtemplatedemail`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersForgotpasswordCreate
   * @request POST:/api/Users/forgotpassword
   * @secure
   */
  usersForgotpasswordCreate = (
    data: ForgotPasswordRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Users/forgotpassword`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersResetpasswordCreate
   * @request POST:/api/Users/resetpassword
   * @secure
   */
  usersResetpasswordCreate = (
    data: ResetPasswordRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Users/resetpassword`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UsersSuperadminCheckCreate
   * @request POST:/api/Users/superadmin/check
   * @secure
   */
  usersSuperadminCheckCreate = (
    query?: {
      pass?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Users/superadmin/check`,
      method: 'POST',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesIngestCreate
   * @request POST:/api/Variables/ingest
   * @secure
   */
  variablesIngestCreate = (data: Metric[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/ingest`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesGetTaskFormulaVariableValuesList
   * @request GET:/api/Variables/GetTaskFormulaVariableValues
   * @secure
   */
  variablesGetTaskFormulaVariableValuesList = (
    query?: {
      /** @format int32 */
      TaskId?: number;
      /** @format date-time */
      StartDate?: string;
      /** @format date-time */
      EndDate?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/GetTaskFormulaVariableValues`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTaskCreate
   * @request POST:/api/Variables/task
   * @secure
   */
  variablesTaskCreate = (
    data: CreateVariableTaskDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/task`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTaskUpdate
   * @request PUT:/api/Variables/task
   * @secure
   */
  variablesTaskUpdate = (
    data: VariableTaskDto,
    query?: {
      /** @default false */
      wipeData?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/task`,
      method: 'PUT',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesGetDataFromVariableDetail
   * @request GET:/api/Variables/GetDataFromVariable/{id}
   * @secure
   */
  variablesGetDataFromVariableDetail = (
    id: number,
    query?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
      /** @default false */
      downsample?: boolean;
      /**
       * @format int32
       * @default 500
       */
      points?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/GetDataFromVariable/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesExportDataList
   * @request GET:/api/Variables/ExportData
   * @secure
   */
  variablesExportDataList = (
    query?: {
      variableIds?: number[];
      /**
       * @format int32
       * @default 100
       */
      limit?: number;
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
      fileType?: ExportFileType;
      /**
       * @format int32
       * @default 0
       */
      exportId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, ProblemDetails>({
      path: `/api/Variables/ExportData`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesGetLastDataByDashboardIdDetail
   * @request GET:/api/Variables/GetLastDataByDashboardId/{dashboardId}
   * @secure
   */
  variablesGetLastDataByDashboardIdDetail = (
    dashboardId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/GetLastDataByDashboardId/${dashboardId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesGetLastDataFromDiagramIdDetail
   * @request GET:/api/Variables/GetLastDataFromDiagramId/{diagramId}
   * @secure
   */
  variablesGetLastDataFromDiagramIdDetail = (
    diagramId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/GetLastDataFromDiagramId/${diagramId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesList
   * @request GET:/api/Variables
   * @secure
   */
  variablesList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDelete
   * @request DELETE:/api/Variables
   * @secure
   */
  variablesDelete = (
    query?: {
      /** @format int32 */
      id?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables`,
      method: 'DELETE',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesScadaList
   * @request GET:/api/Variables/Scada
   * @secure
   */
  variablesScadaList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      /** @format int32 */
      TableId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/Scada`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTasksList
   * @request GET:/api/Variables/Tasks
   * @secure
   */
  variablesTasksList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      CalculationType?: CalculationType;
      CronExpression?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/Tasks`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesInputsList
   * @request GET:/api/Variables/Inputs
   * @secure
   */
  variablesInputsList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      /** @format int32 */
      TableId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/Inputs`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDevicesList
   * @request GET:/api/Variables/Devices
   * @secure
   */
  variablesDevicesList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/Devices`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDetail
   * @request GET:/api/Variables/{id}
   * @secure
   */
  variablesDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesInputDetail
   * @request GET:/api/Variables/Input/{id}
   * @secure
   */
  variablesInputDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/Input/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDeviceDetail
   * @request GET:/api/Variables/Device/{id}
   * @secure
   */
  variablesDeviceDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/Device/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesInputCreate
   * @request POST:/api/Variables/Input
   * @secure
   */
  variablesInputCreate = (
    data: CreateVariableDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/Input`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesInputUpdate
   * @request PUT:/api/Variables/Input
   * @secure
   */
  variablesInputUpdate = (data: VariableDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/Input`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDeviceCreate
   * @request POST:/api/Variables/Device
   * @secure
   */
  variablesDeviceCreate = (data: CreateDeviceDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/Device`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDeviceUpdate
   * @request PUT:/api/Variables/Device
   * @secure
   */
  variablesDeviceUpdate = (data: CreateDeviceDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/Device`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDeviceDelete
   * @request DELETE:/api/Variables/Device
   * @secure
   */
  variablesDeviceDelete = (
    query?: {
      /** @format int32 */
      id?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/Device`,
      method: 'DELETE',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesScadaCreate
   * @request POST:/api/Variables/scada
   * @secure
   */
  variablesScadaCreate = (
    data: CreateVariableScadaDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/scada`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesScadaUpdate
   * @request PUT:/api/Variables/scada
   * @secure
   */
  variablesScadaUpdate = (data: VariableScadaDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/scada`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesScadaDetail
   * @request GET:/api/Variables/scada/{id}
   * @secure
   */
  variablesScadaDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/scada/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesScadaByPlantDetail
   * @request GET:/api/Variables/scada/by-plant/{id}
   * @secure
   */
  variablesScadaByPlantDetail = (
    id: number,
    query?: {
      /** @default false */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/scada/by-plant/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesScadaByZoneDetail
   * @request GET:/api/Variables/scada/by-zone/{id}
   * @secure
   */
  variablesScadaByZoneDetail = (
    id: number,
    query?: {
      /** @default false */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/scada/by-zone/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTaskByPlantDetail
   * @request GET:/api/Variables/task/by-plant/{id}
   * @secure
   */
  variablesTaskByPlantDetail = (
    id: number,
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @format int32 */
      ZoneId?: number;
      CalculationType?: CalculationType;
      CronExpression?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/task/by-plant/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTaskByZoneDetail
   * @request GET:/api/Variables/task/by-zone/{id}
   * @secure
   */
  variablesTaskByZoneDetail = (
    id: number,
    query?: {
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/task/by-zone/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesScadaByTableDetail
   * @request GET:/api/Variables/scada/by-table/{id}
   * @secure
   */
  variablesScadaByTableDetail = (
    id: number,
    query?: {
      /** @default false */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/scada/by-table/${id}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTaskDetail
   * @request GET:/api/Variables/task/{id}
   * @secure
   */
  variablesTaskDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/task/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTaskByTableDetail
   * @request GET:/api/Variables/task/by-table/{id}
   * @secure
   */
  variablesTaskByTableDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/task/by-table/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesInputByTableDetail
   * @request GET:/api/Variables/input/by-table/{id}
   * @secure
   */
  variablesInputByTableDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/input/by-table/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesByTableAndNameDetail
   * @request GET:/api/Variables/byTable/{tableId}/andName/{variableName}
   * @secure
   */
  variablesByTableAndNameDetail = (
    tableId: number,
    variableName: string,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/byTable/${tableId}/andName/${variableName}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesDeviceByPlantDetail
   * @request GET:/api/Variables/Device/ByPlant/{plantId}
   * @secure
   */
  variablesDeviceByPlantDetail = (
    plantId: number,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/Device/ByPlant/${plantId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTaskTreeList
   * @request GET:/api/Variables/task/tree
   * @secure
   */
  variablesTaskTreeList = (
    query?: {
      /** @format int32 */
      taskId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/task/tree`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesMetricsCreate
   * @request POST:/api/Variables/metrics
   * @secure
   */
  variablesMetricsCreate = (data: Metric[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Variables/metrics`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesNameUpdate
   * @request PUT:/api/Variables/{variableId}/name
   * @secure
   */
  variablesNameUpdate = (
    variableId: number,
    data: string,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/${variableId}/name`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTasksCheckExecutionsInRangeList
   * @request GET:/api/Variables/tasks/check-executions-in-range
   * @secure
   */
  variablesTasksCheckExecutionsInRangeList = (
    query?: {
      TaskIds?: number[];
      /** @format int32 */
      PlantId?: number;
      /** @format date-time */
      StartDate?: string;
      /** @format date-time */
      EndDate?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/tasks/check-executions-in-range`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTasksExecuteInRangeCreate
   * @request POST:/api/Variables/tasks/execute-in-range
   * @secure
   */
  variablesTasksExecuteInRangeCreate = (
    data: ExecuteTasksInRangeRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/tasks/execute-in-range`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTasksSaveExecutionResultsCreate
   * @request POST:/api/Variables/tasks/save-execution-results/{executionId}
   * @secure
   */
  variablesTasksSaveExecutionResultsCreate = (
    executionId: string,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/tasks/save-execution-results/${executionId}`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTasksCheckVariableTaskCreate
   * @request POST:/api/Variables/tasks/check-variable-task
   * @secure
   */
  variablesTasksCheckVariableTaskCreate = (
    data: CheckVariableTaskRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/tasks/check-variable-task`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTasksTestVariableTaskCreate
   * @request POST:/api/Variables/tasks/test-variable-task
   * @secure
   */
  variablesTasksTestVariableTaskCreate = (
    data: TestVariableTaskRequestDto,
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/tasks/test-variable-task`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Variables
   * @name VariablesTasksExecutionResultsDetail
   * @request GET:/api/Variables/tasks/execution-results/{executionId}
   * @secure
   */
  variablesTasksExecutionResultsDetail = (
    executionId: string,
    query?: {
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 100
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Variables/tasks/execution-results/${executionId}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags VariablesBulk
   * @name VariablesBulkCreate
   * @request POST:/api/VariablesBulk/{idPlanta}
   * @secure
   */
  variablesBulkCreate = (
    idPlanta: number,
    data: BulkVariableScadaDto[],
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/VariablesBulk/${idPlanta}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Zones
   * @name ZonesList
   * @request GET:/api/Zones
   * @secure
   */
  zonesList = (
    query?: {
      SearchString?: string;
      /** @format int32 */
      PlantId?: number;
      /** @default true */
      isPaginated?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/api/Zones`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Zones
   * @name ZonesCreate
   * @request POST:/api/Zones
   * @secure
   */
  zonesCreate = (data: CreateZoneDto, params: RequestParams = {}) =>
    this.request<CreateResponseDto, any>({
      path: `/api/Zones`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Zones
   * @name ZonesDetail
   * @request GET:/api/Zones/{id}
   * @secure
   */
  zonesDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Zones/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Zones
   * @name ZonesUpdate
   * @request PUT:/api/Zones/{id}
   * @secure
   */
  zonesUpdate = (id: number, data: ZoneDto, params: RequestParams = {}) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Zones/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Zones
   * @name ZonesDelete
   * @request DELETE:/api/Zones/{id}
   * @secure
   */
  zonesDelete = (
    id: number,
    query?: {
      pass?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<CreateEditRemoveResponseDto, any>({
      path: `/api/Zones/${id}`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Zones
   * @name ZonesByPlantDetail
   * @request GET:/api/Zones/ByPlant/{id}
   * @secure
   */
  zonesByPlantDetail = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Zones/ByPlant/${id}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Zones
   * @name ZonesExcelCreate
   * @request POST:/api/Zones/Excel
   * @secure
   */
  zonesExcelCreate = (data: CreateZoneDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/Zones/Excel`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
